import React from 'react'
import './FooterStyles.css'

const Footer = () => {
  return (
    <div className="footer">
        <p>Website by <a href="https://matthewsiperko.github.io/">Matthew Siperko</a> &copy; 2021</p>
    </div>
  )
}

export default Footer